import type { GetStaticPaths, GetStaticProps } from 'next';

import {
  ArticlePage,
  NOT_FOUND_REVALIDATE_SECONDS,
  REVALIDATE_SECONDS
} from '../../../articles/[slug]/index';
import type { ArticlePageProps } from '../../../articles/[slug]/index';
import { hydrateArticleBlocks } from '@lib/article-blocks/hydrate';
import {
  getAllTeamRevealPathsQuery,
  getTeamReveal,
  sanityClient
} from '@lib/sanity';

type TeamRevealPathEntry = { slug: string; authorSlug: string };

export const getStaticPaths: GetStaticPaths = async () => {
  const entries = await sanityClient.fetch<TeamRevealPathEntry[]>(
    getAllTeamRevealPathsQuery
  );

  return {
    paths: entries
      .filter((entry) => entry.slug && entry.authorSlug)
      .map((entry) => ({
        params: { author: entry.authorSlug, slug: entry.slug }
      })),
    fallback: 'blocking'
  };
};

export const getStaticProps: GetStaticProps<ArticlePageProps> = async ({
  params
}) => {
  const authorSlug = params?.author as string;
  const slug = params?.slug as string;
  const page = await getTeamReveal({ authorSlug, slug });

  if (!page) {
    return { notFound: true, revalidate: NOT_FOUND_REVALIDATE_SECONDS };
  }

  const blockData = await hydrateArticleBlocks(page.body);

  return {
    props: { page, blockData },
    revalidate: REVALIDATE_SECONDS
  };
};

export default ArticlePage;
